<template lang="pug">
  .abilityGroup
    p.abilityGroup__title 刪除規定
    .abilityGroup__item
      span.abilityGroup__subtitle 刪除全部使用者
      BaseAbilityRadioGroup(
        :value="abilityUserDeletion"
        :disabled="disabled"
        :unreadableAbility="true"
        @handleRadioChange="setAbilityUserDeletion")
</template>
<script>
import BaseAbilityRadioGroup from '@/components/common/select/BaseAbilityRadioGroup'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      abilityUserDeletion: 'positionStore/getCurrentAbilityUserDeletion',
    }),
  },
  methods: {
    ...mapActions({
      setAbilityUserDeletion: 'positionStore/setAbilityUserDeletion',
    }),
  },
  components: {
    BaseAbilityRadioGroup,
  },
}
</script>
<style lang="scss" scoped>
@import 'src/scss/_abilityGroup';
</style>



// WEBPACK FOOTER //
// src/pages/manager/AbilityRadioGroup/AbilityGroupUserDelete.vue